import { Component, OnInit, signal } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { User } from '../../model/user.model';
import { CurrentUserService } from '../../services/currentUser.service';
import { MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDivider } from '@angular/material/divider';
import { DatePipe } from '../../pipes/date.pipe';

@Component({
  selector: 'app-view-eula',
  templateUrl: './view-eula.component.html',
  styleUrls: ['./view-eula.component.scss'],
  imports: [
    MatDialogTitle,
    MatIcon,
    MatIconButton,
    MatDialogClose,
    CdkScrollable,
    MatDialogContent,
    MatDivider,
    DatePipe
  ]
})
export class ViewEulaComponent implements OnInit {
  currentUser: User;
  timezone: string;
  eulaContent = signal<SafeHtml>('');

  constructor(
    private currentUserService: CurrentUserService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.currentUser = this.currentUserService.currentUserValue;
    this.timezone = this.currentUserService?.timeZone;
    fetch('assets/eula/EULA.html')
      .then((res) => res.text())
      .then((data) => {
        this.eulaContent.set(this.sanitizer.bypassSecurityTrustHtml(data));
      });
  }
}
